import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      email: '',
      permissions: {},
      type: ''
    }
  },
  actions: {
    logoutUser ({ commit }) {
      commit('setUser', {});
    }
  },
  mutations: {
    setUserID (state, id) {
      Vue.set(state.user, 'id', parseInt(id, 10));
    },
    setUserEmail (state, email) {
      Vue.set(state.user, 'email', email);
    },
    setUserType (state, type) {
      Vue.set(state.user, 'type', type);
    },
    setUserPermissions (state, permissions) {
      Vue.set(state.user, 'permissions', JSON.parse(JSON.stringify(permissions)));
    }
  },
  getters: {
    getUserID: (state) => state.user.id,
    getUserEmail: (state) => state.user.email,
    getUserType: (state) => state.user.type,
    getUserPermission: (state) => (permission) => !!state.user.permissions[permission]
  }
});
